import {
  BodypartType,
  MovementPatternType,
} from "@growth-machine-llc/stridist-api-client";
import { workoutsClient } from "../api/ApiClients";
import ServiceBase from "./ServiceBase";

class WorkoutResultsService extends ServiceBase {
  async getUserExerciseResults(
    pageNumber: number,
    pageSize: number,
    clientId: number | null | undefined,
  ) {
    return workoutsClient.getUserExerciseResults(
      pageNumber,
      pageSize,
      clientId,
      null,
      null,
    );
  }
  async getUserWorkoutGroups(
    pageNumber: number,
    pageSize: number,
    clientId: number,
  ) {
    return workoutsClient.getUserWorkoutGroups(pageNumber, pageSize, clientId);
  }

  async getUserExerciseHistory(
    clientId: number | null | undefined,
    exerciseId: number | null | undefined,
    clientUsername: string | null | undefined,
  ) {
    return workoutsClient.getUserExerciseResults(
      1,
      9999,
      clientId,
      exerciseId,
      clientUsername,
    );
  }

  async getUserExercises(
    pageNumber: number,
    pageSize: number,
    clientId: number | null | undefined,
    searchQuery: string | null | undefined,
    bodypart: BodypartType[] = null,
    movementPattern: MovementPatternType[] = null,
    tagIds: number[] = null,
  ) {
    return workoutsClient.getUserExercises(
      pageNumber,
      pageSize,
      clientId,
      searchQuery,
      bodypart,
      movementPattern,
      tagIds,
    );
  }

  async getCompletedExercisesByDateRanges(
    clientId: number | null | undefined,
    startDate?: string | null | undefined,
    endDate?: string | null | undefined,
  ) {
    return workoutsClient.getCompletedExercisesByDateRanges(
      clientId,
      startDate,
      endDate,
    );
  }
}

export default new WorkoutResultsService();
